import React, { useState } from 'react';
import {
  Alert,
  Button,
  Card,
  CardBody,
  CardText,
  CardTitle,
  Col,
  Collapse,
  Container,
  Row
} from 'reactstrap';
import { version } from '../index';

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <Container>
        <Row className="justify-content-center">
          <Col md={8} >
            <Card className="shadow border-0">
              <CardBody className="p-4 p-md-5">
                <div className="text-center mb-4">
                  <div className="mb-3">
                    <i className="fas fa-exclamation-triangle text-danger" style={{ fontSize: '3rem' }}></i>
                  </div>
                  <CardTitle tag="h2" className="text-danger mb-3">
                    Something went wrong
                  </CardTitle>
                  <CardText className="text-muted">
                    We're sorry, but something unexpected happened. Please contact support.
                  </CardText>
                </div>

                <div className="mb-4">
                    <Alert color="light" className="mt-3">
                     {!isOpen && <pre className="mb-0 small text-muted" style={{ whiteSpace: 'pre-wrap' }}>
                        {error.name}<br></br>
                        {error.message}<br></br>
                        <br></br>
                        <a className="text-primary" onClick={() => setIsOpen(!isOpen)}>More...</a>
                      </pre>}
                      <Collapse isOpen={isOpen}>
                      <pre className="mb-0 small text-muted" style={{ whiteSpace: 'pre-wrap' }}>
                        {error.name}<br></br>
                        {error.message}<br></br>
                        {version}<br></br>
                        <br></br>
                        {error.stack}<br></br>
                        {error.componentStack}<br></br>
                      </pre>
                      </Collapse>
                    </Alert>

                </div>

                <div className="text-center">
                  <Button
                    color="primary"
                    size="lg"
                    onClick={resetErrorBoundary}
                    className="px-4"
                  >
                    <i className="fas fa-redo me-2"></i>
                    Try Again
                  </Button>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ErrorFallback;